/**
 * ACCORDION MOTION (2026-09-28, motion board item 5).
 *
 * The buy panel's rows (snippets/d2-offer-body.liquid, .acc-item) and both FAQ
 * lists (sections/d2-faq.liquid, sections/d2-faq-page.liquid, .faq-item) are
 * plain <details>. The browser opens them in one frame and lets any number
 * stay open. The reference, measured at 390: the row's height runs over .7s
 * on the site curve and pushes everything below it down, opening one row
 * closes the open one at the same time, and the sign's upright bar turns
 * three quarters round onto the flat one while the whole sign drops to half
 * strength. Duration and curve are read from --d2-dur / --d2-ease.
 *
 * Delegated from the document, so rows a section re-render swaps in (morph.js
 * keeps their open state) still animate. The rows stay real <details>: without
 * this file, or with reduced motion, the browser's own toggle is what you get
 * (reduced motion keeps the one-at-a-time rule, not the movement).
 */
(() => {
  const ROW = 'details.acc-item, details.faq-item';
  if (!document.querySelector(ROW)) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tokens = getComputedStyle(document.documentElement);
  const DUR = (parseFloat(tokens.getPropertyValue('--d2-dur')) || 0.7) * 1000;
  const EASE = tokens.getPropertyValue('--d2-ease').trim() || 'cubic-bezier(0.76, 0, 0.24, 1)';
  const running = new WeakMap();

  // Marks a row as driven by this file; the sign's rotation and fade in
  // assets/duet-tokens.css key on it, so untouched markup keeps its old look.
  const mark = (row) => row.setAttribute('data-d2-acc', '');
  document.querySelectorAll(ROW).forEach(mark);

  const stop = (row) => {
    const anim = running.get(row);
    if (anim) anim.cancel();
  };

  const tidy = (row) => {
    running.delete(row);
    row.style.removeProperty('overflow');
    row.style.removeProperty('box-sizing');
  };

  const glide = (row, from, to, done) => {
    if (reduce || Math.abs(to - from) < 1) {
      done();
      return;
    }
    row.style.overflow = 'hidden';
    row.style.boxSizing = 'border-box';
    const anim = row.animate([{ height: `${from}px` }, { height: `${to}px` }], { duration: DUR, easing: EASE });
    running.set(row, anim);
    anim.onfinish = () => {
      tidy(row);
      done();
    };
    anim.oncancel = () => tidy(row);
  };

  const open = (row) => {
    const from = row.offsetHeight;
    stop(row);
    row.classList.remove('is-closing');
    row.open = true;
    const to = row.offsetHeight;
    glide(row, from, to, () => {});
  };

  const close = (row) => {
    const from = row.offsetHeight;
    stop(row);
    row.classList.add('is-closing');
    row.open = false;
    const to = row.offsetHeight;
    row.open = true;
    glide(row, from, to, () => {
      row.open = false;
      row.classList.remove('is-closing');
    });
  };

  const isOpen = (row) => row.open && !row.classList.contains('is-closing');

  document.addEventListener('click', (event) => {
    const node = event.target instanceof Element ? event.target : null;
    const summary = node && node.closest('summary');
    if (!summary) return;
    const row = summary.parentElement;
    if (!row || !row.matches(ROW)) return;
    // links inside a summary keep working
    if (node.closest('a') && summary.contains(node.closest('a'))) return;

    event.preventDefault();
    mark(row);
    if (isOpen(row)) {
      close(row);
      return;
    }
    Array.from(row.parentElement.children).forEach((other) => {
      if (other !== row && other.matches(ROW) && isOpen(other)) {
        mark(other);
        close(other);
      }
    });
    open(row);
  });
})();
